
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { PoolModel } from './Entities.GormCrm.Pool';
import { DynamicQueryModel } from './Models.DynamicQuery';
import { Model, ModelProperty } from 'models/Model';


export class SavePoolRequestModel extends Model<SavePoolRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'pool', type: 'PoolModel', languageString: 'savePoolRequest.property.pool', isHidden: true, isObject: true, new: () => { return new PoolModel }, properties: () => { return PoolModel.classProperties } },
		{ name: 'queryData', type: 'DynamicQueryModel', languageString: 'savePoolRequest.property.queryData', isHidden: true, isObject: true, new: () => { return new DynamicQueryModel }, properties: () => { return DynamicQueryModel.classProperties } }
	];
	[key: string]: any;
	
	public pool?: PoolModel;
	public queryData?: DynamicQueryModel;
    
	constructor(){
		super();
		this.pool = undefined;
		this.queryData = undefined;
		
	}
	getProperties(){
		return SavePoolRequestModel.classProperties;
	}
}

